import { render, staticRenderFns } from "./EditRoleForm.vue?vue&type=template&id=c17d849a&"
import script from "./EditRoleForm.vue?vue&type=script&lang=js&"
export * from "./EditRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports